import { render, staticRenderFns } from "./refundTransaction.vue?vue&type=template&id=40613372&"
import script from "@/scripts/gpuHub/transactions/refundTransaction.js?vue&type=script&lang=js&"
export * from "@/scripts/gpuHub/transactions/refundTransaction.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports